var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlAutoRentalFilled = function SvgHtlAutoRentalFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.063 11.5H5.937a2 2 0 0 1-3.926-.282l-.279-.28A2.482 2.482 0 0 1 1 9.172v-.1a2.492 2.492 0 0 1 1.112-2.077 1.5 1.5 0 0 0 .608-.834l.384-1.344a2.51 2.51 0 0 1 2.4-1.814h2.831a2.508 2.508 0 0 1 2.171 1.26L11.55 6.09a1.5 1.5 0 0 0 .828.679l1.083.361a2.24 2.24 0 0 1 1.535 2.129V10a1.5 1.5 0 0 1-1.046 1.43 2 2 0 0 1-3.891.07h.004ZM12 12a1 1 0 1 0-.192-1.981 1.506 1.506 0 0 0-.384.165 1 1 0 0 0-.424.794v.046A1 1 0 0 0 12 12Zm-8 0a1 1 0 1 0-1-1.015v.029A1 1 0 0 0 4 12Z"
  })));
};
export default SvgHtlAutoRentalFilled;